// @flow
import Vue from 'vue'

/**
 * Require and code split / lazy load subscription components
 */
const subscriptionCodeSplit = () => {
  /* SUBSCRIPTIONS */
  Vue.component('fbplus-welcome', () =>
    import(/* webpackChunkName: "user" */ '../components/videos/fbplus-welcome.vue'),
  )

  Vue.component('subscription-cancel', () =>
    import(/* webpackChunkName: "user" */ '../components/subscriptions/subscription-cancel.vue'),
  )

  Vue.component('subscription-resume', () =>
    import(/* webpackChunkName: "user" */ '../components/subscriptions/subscription-resume.vue'),
  )

  Vue.component('subscription-checkout-form', () =>
    import(
      /* webpackChunkName: "user" */ '../components/subscriptions/subscription-checkout-form.vue'
    ),
  )

  Vue.component('subscription-update-payment', () =>
    import(
      /* webpackChunkName: "user" */ '../components/subscriptions/subscription-update-payment.vue'
    ),
  )

  Vue.component('subscription-add-wallet-discount', () =>
    import(
      /* webpackChunkName: "user" */ '../components/subscriptions/subscription-add-wallet-discount.vue'
    ),
  )

  /* ORGANIZATION REGISTRATION */
  Vue.component('organization-join-form', () =>
    import(/* webpackChunkName: "user" */ '../components/organizations/organization-join-form.vue'),
  )

  Vue.component('subscription-organization-cancel', () =>
    import(
      /* webpackChunkName: "user" */ '../components/subscriptions/subscription-organization-cancel.vue'
    ),
  )
}

export default subscriptionCodeSplit
